// Ref: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address

const emailRegExStrBasic = '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$'
export const emailRegEx = new RegExp(emailRegExStrBasic, 'g')

// The following characters have been problematic in Blend and have caused users to get stuck in a loop
// trying to verify their email and access their Blend account.
// https://help.blend.com/hc/en-us/articles/360004955632-Encompass-error-Illegal-characters-in-path
// More info in Slack convo: https://knockaway.slack.com/archives/CCUSXTCF5/p1664234064611479
// prettier-ignore
export const INVALID_CHARS_FOR_NAME_BLEND = ['@','#','$','%','&','(',')','*','+','~','!','^','.']
// prettier-ignore
export const INVALID_CHARS_FOR_NAME = ['@','#','$','%','&','(',')','*','+','~','!','^','.',',','/','\\','?',';','`','{','}','<','>',':','=','|','«»','"','¨','_','§','¹','²','³','£','¢','¬','[',']','°','º','ª']
